import { render } from "./selectIdAndName.vue?vue&type=template&id=174a2b51"
import script from "./selectIdAndName.vue?vue&type=script&lang=js"
export * from "./selectIdAndName.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__